<template>
  <v-list v-if="show">
    <v-list-tile
      class="list-divider-tile mt-2"
      :class="contentCSS"
    >
      <v-subheader class="list-divider-subheader grey--text text--darken-3">
        <v-layout
          row
          wrap
        >
          <div class="mr-1">
            {{ label }}
          </div>
          <div v-if="showActivationLink">
            <a
              href="javascript:void(0)"
              class="ml-1"
              @click="onLinkClicked"
            >{{
              $t('activateContentNow')
            }}</a>
          </div>
        </v-layout>
      </v-subheader>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    showActivationLink: {
      type: Boolean,
      default: false,
    },
    onLinkClicked: {
      type: Function,
      default: null,
    },
    /* A css classes string like 'class1 class2 class3' */
    contentClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    contentCSS() {
      if (!this.contentClass) {
        return {};
      }
      const css = {};
      css[this.contentClass] = true;
      return css;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NoEntriesHeader.vue